import { ReactiveVar } from '@apollo/client';
import { INoDataOverlayInfo } from '@starryui10/overlays/NoDataOverlay';
import React from 'react';

interface IServerPageGridContext {
    currentPageCache: ReactiveVar<number>;
    pageAmount: ReactiveVar<number>;
    getCurrentHighlight: ReactiveVar<string>;
    totalRecords?: number;
    noResultsMessage?: INoDataOverlayInfo | null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ServerGridContext = React.createContext<IServerPageGridContext>({} as any);

export const useServerGridContext = () => React.useContext<IServerPageGridContext>(ServerGridContext);

export const ServerGridContextProvider = ({ children, value }: { children: React.ReactNode; value: IServerPageGridContext }) => (
    <ServerGridContext.Provider value={value}>{children}</ServerGridContext.Provider>
);
